import { render, staticRenderFns } from "./physique.vue?vue&type=template&id=d804be6a&scoped=true&"
import script from "./physique.vue?vue&type=script&lang=js&"
export * from "./physique.vue?vue&type=script&lang=js&"
import style0 from "./physique.vue?vue&type=style&index=0&id=d804be6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d804be6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d804be6a')) {
      api.createRecord('d804be6a', component.options)
    } else {
      api.reload('d804be6a', component.options)
    }
    module.hot.accept("./physique.vue?vue&type=template&id=d804be6a&scoped=true&", function () {
      api.rerender('d804be6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menopauseovary/physique.vue"
export default component.exports